<template>
  <ul :class="containerClass" aria-label="Accès rapide">
    <li v-for="(link,index) in links" :key="`${index}`">
      <a
        tabindex="0"
        :data-target-focus="getLinkTarget(link)"
        @click="skipTo($event, link)"
        @keypress="targetFocus($event, link)"
      >{{ getLinkText(link) }}</a>
    </li>
  </ul>
</template>

<script>
import ApplicationSkipLinksConfig from "./ApplicationSkipLinksConfig";

// touches actives sur les skiplinks :
const ENTER = 13;
const SPACE = 32;
const SKIPKEYS = [ENTER, SPACE];

// éléments atteignables prédéfinis :
const containerTags = (container, tags) => {
  return tags
    .map(tag => {
      return `${container} ${tag}`;
    })
    .join(",");
};

const FOCUSABLES_TAGS = [
  "a[href]:not([tabindex='-1'])",
  "area[href]:not([tabindex='-1'])",
  "input:not([disabled]):not([tabindex='-1'])",
  "select:not([disabled]):not([tabindex='-1'])",
  "textarea:not([disabled]):not([tabindex='-1'])",
  "button:not([disabled]):not([tabindex='-1'])",
  "iframe:not([tabindex='-1'])",
  "[tabindex]:not([tabindex='-1'])",
  "[contentEditable=true]:not([tabindex='-1'])"
];

const FOCUSABLES_COMPONENTS = {
  menu: "#applicationMenu a",
  search: ".dropdown-recherche-auth [data-bs-toggle='dropdown']",
  content: containerTags("#applicationContent", FOCUSABLES_TAGS),
  footer: "#applicationFooter a"
};

/**
 * Composant de génération des liens d'évitement de l'application
 *
 *
 * @author <span><span class="fw-bold">Pascal Ouzeau</span><a class="ms-2" href="mailto:pascal.ouzeau@dgfip.finances.gouv.fr">pascal.ouzeau@dgfip.finances.gouv.fr</a></span>
 * @since Version 1.0
 * @version 1.2
 * @displayName ApplicationSkipLinks
 */
export default {
  name: "ApplicationSkipLinks",
  props: {
    config: { type: Object, default: () => ApplicationSkipLinksConfig }
  },
  computed: {
    containerClass() {
      return this.prefixStringKey(this.config, "containerClass", {
        prefix: "skiplinks "
      });
    },
    links() {
      const page = this.getKey(this.config, "pages", []).filter(
        page => page.name === this.$route.name
      );
      const pageLinks = page.length
        ? this.getKey(page[0], "links", [])
        : this.getKey(this.config, "defaultLinks", []);
      let convertedLinks = pageLinks.map(link => {
        const linkTarget = this.getKey(link, "target");
        const target = FOCUSABLES_COMPONENTS[linkTarget] || linkTarget;
        return { text: this.getLinkText(link), target: target };
      });
      const validLinks = convertedLinks.filter(link =>
        document.querySelector(this.getLinkTarget(link))
      );
      return validLinks;
    }
  },
  methods: {
    getLinkText(link) {
      return this.getKey(link, "text", "");
    },
    getLinkTarget(link) {
      return this.getKey(link, "target", "");
    },
    skipTo(e, link) {
      e.preventDefault();
      document.querySelector(this.getLinkTarget(link)).focus();
    },
    targetFocus(e, link) {
      if (SKIPKEYS.indexOf(e.keyCode) !== -1) {
        e.preventDefault();
        this.skipTo(e, link);
      }
    }
  }
};
</script>
<style scoped>
.skiplinks a,
.skiplinks a:hover {
  color: var(--bs-gray);
  text-decoration: underline;
  cursor: pointer;
}
</style>